<script>
    import {_} from 'svelte-i18n';
    import EventEditButton from "./EventEditButton.svelte";

    export let event;
</script>

<div class="d-block p-2 text-white">
    <EventEditButton {event} form="minimumAge"/>
    {$_('component.event.ageRestrictionsText', { values: { minimumAge: event.minimum_age }})}
</div>

<style>
    div {
        background-color: #9b9d9f;
    }
</style>